import 'waypoints/lib/jquery.waypoints.js';
import 'jquery-placeholder';
import 'jquery-ui/ui/widgets/datepicker.js';
import bowser from 'bowser';

class Global {

    constructor() {
        this.waypoints(); // Global waypoints
        this.detectChromeiOS();
        $(document).ready(() => {
            return this.documentReadyEventHandler();
        });
    }

    // Detect if the browser is chrome on ios
    detectChromeiOS() {
        if (navigator.userAgent.match('CriOS')) {
            return $('body').addClass('browser-chrome-ios');
        }
    }

    // Setup the placeholders polyfill for IE
    placeholders() {
        return $('input, textarea').placeholder();
    }

    // Include vendor scripts as we need them
    // so that the javascript doesn't contain 50 files
    // that are only used on one page each.
    asyncScript(src, callback) {
        let r = false;
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = src;
        s.onload = (s.onreadystatechange = function() {
            if (!r && (!this.readyState || (this.readyState === 'complete'))) {
                r = true;
                return callback();
            }
        });
        const t = document.getElementsByTagName('script')[0];
        return t.parentNode.insertBefore(s, t);
    }

    // Include any css files that relate to the above
    asyncStyles(src) {
        let r = false;
        const s = document.createElement('link');
        s.type = 'text/css';
        s.rel = 'stylesheet';
        s.href = src;
        s.onload = (s.onreadystatechange = function() {
            if (!r && (!this.readyState || (this.readyState === 'complete'))) {
                return r = true;
            }
        });
        const t = document.getElementsByTagName('link')[0];
        return t.parentNode.insertBefore(s, t);
    }

    documentReadyEventHandler() {
        $('body').addClass('ready');
        this.placeholders();
        this.datepickers();
        return this.compatCheck();
    }

    waypoints() {
        return $('[data-waypoint]').each((i, el) =>
            $(el).waypoint({
                handler(direction) {
                    return $(el).addClass('inview');
                },
                offset: $(el).data('waypoint-offset'),
            }),
        );
    }

    // Set up datepickers
    datepickers() {
        const datePicker = $('[data-datepicker]');

        return datePicker.datepicker({
            dateFormat: (datePicker.attr('data-datepicker') === 'register') ? 'dd/mm/yy' : 'dd-mm-yy',
            constrainInput: false,
            firstDay: 1,
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
        });
    }

    // Check if browser is compat.
    compatCheck() {
        // Check for IE <9
        if (bowser.msie && (bowser.version <= 8)) {
            $('#ie8-banner').show();
            return $('body').addClass('ie8');
        }
    }

    tooltips() {
        return $('.tooltip-item').tooltipster({
            theme: 'tooltip-item-theme',
            contentAsHTML: true,
            offsetY: -22,
            interactive: true,
        });
    }
}

export default Global;
